import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component'; 
import { UnsubscribeeventsComponent } from './components/unsubscribeevents/unsubscribeevents.component';
import { SubscribeeventsComponent } from './components/subscribeevents/subscribeevents.component';
import { ManageallsubscriptionsComponent } from './components/manageallsubscriptions/manageallsubscriptions.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { UnsubscribefromnotificationComponent } from './components/unsubscribefromnotification/unsubscribefromnotification.component';

@NgModule({
  declarations: [
    AppComponent, 
    UnsubscribeeventsComponent,
    SubscribeeventsComponent,
    ManageallsubscriptionsComponent,
    UnsubscribeComponent,
    UnsubscribefromnotificationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
   // {provide: LocationStrategy, useClass: HashLocationStrategy}
   {provide: LocationStrategy, useClass: PathLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
